function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "big-logo",
  x1: 1.094,
  y1: 0.601,
  x2: -0.091,
  y2: 0.535,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#08b794"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#069edd"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3153",
  transform: "translate(-3.685 -3.685)",
  fill: "url(#big-logo)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 41086",
  d: "M39.76 75.835a36.075 36.075 0 01-25.509-61.584 36.075 36.075 0 1151.018 51.018A35.839 35.839 0 0139.76 75.835zm0-68.629a32.553 32.553 0 00-23.019 55.573 32.553 32.553 0 1046.038-46.038A32.34 32.34 0 0039.76 7.206z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 41087",
  d: "M28.319 55.246a1.75 1.75 0 01-1.245-.516l-9.331-9.333 2.49-2.49 8.087 8.089 27.5-27.5 2.49 2.49L29.566 54.73a1.75 1.75 0 01-1.247.516z"
}));

function SvgSuccess(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.15,
    height: 72.15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e2fed3dc.svg";
export { ForwardRef as ReactComponent };